import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Injectable, Injector } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { JwtService } from '../../core/services';
import { SessionStateService } from '../../core/services/session-state.service';
import { LoginService } from '../components/login/login.service';

const MAX_NUM_RETRIES = 3;
let retryNumber = 0;

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService,
    private loginService: LoginService,
    private injector: Injector,
    private router: Router,
    private jwtService: JwtService,
    private sessionStateService: SessionStateService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {

    if (req.url.includes('RedyManuals')) {
      const headers: HttpHeaders = req.headers.set('Accept', 'application/pdf');
      const request = req.clone({
        url: req.url,
        headers: headers,
        responseType: 'blob'
      });
      return next.handle(request);
    }
    if (req.url === 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/FAQ.json') {
      return next.handle(req);
    }
    if (req.url.includes('i18n')) {
      return next.handle(req);
    }
    if (req.url === 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/taxes.json') {
      return next.handle(req);
    }
    if (req.url.includes('https://www.meteroptimizationserver.com/')) {
      const headers: HttpHeaders = req.headers.set('Authorization', 'Basic '
        + btoa(`EdpSigFox:jkMg8NCm`));

      const request = req.clone({
        url: req.url,
        headers: headers
      });

      return next.handle(request);
    }
    if (req.url.includes('sonnenbatteryapi')) {
      const headers: HttpHeaders = req.headers.set('Accept', 'application/vnd.sonnenbatterie.api.core.v1+json')
        .set('Authorization', 'Bearer 2a0e7ca0a129df5bbd81791d2aedcd85482b29b34f76182ab9e08f20b7363ffe');

      const request = req.clone({
        url: req.url,
        headers: headers
      });
      return next.handle(request);
    }

    if (req.url.includes('https://staging.redy-reports.whitesmith.co')) {
      return next.handle(req);
    }
    if (req.url.includes('https://report.redy.edp.pt')) {
      return next.handle(req);
    }
    if (req.url === 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/hvac.json') {
      return next.handle(req);
    }
    if (req.url.includes('account-confirmation')) {
      const enrichedReq = req.clone({
        url: this.getFullUrl(req.url),
      });
      return next.handle(enrichedReq);

    } else {
      const newReq = this.addAuthHeader(req);
      return next.handle(newReq).catch(error => {
         if (error.status === 401) {
          return this.refreshToken(req, next);
         }
         return Observable.throw(error);
      });
    }
  }

  private getFullUrl(url: string): string {
    const fullUrl = `${environment.uiApi.url}${url}`;
    return fullUrl;
  }


  private getAuthorizationValue(): string {
    return this.jwtService.getIdToken();
  }

  private getHeaders(req: HttpRequest<any>): HttpHeaders {
    let headers: HttpHeaders = req.headers;
    headers = req.headers.set('Authorization', this.getAuthorizationValue());
    const time = this.jwtService.getTimeToken();
    return headers;
  }

  addAuthHeader(request) {
    const authHeader = this.getHeaders(request);
    if (authHeader) {
      return request.clone({
        url: this.getFullUrl(request.url),
        headers: this.getHeaders(request)
      });
    }
    return request;
  }

  refreshToken(originalRequest: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return this.authenticationService.getSession()
    .flatMap(() => {
            const newReqRepeat = this.addAuthHeader(originalRequest);
            return next.handle(newReqRepeat);
        });
  }

  // logout() {
  //   this.authenticationService.logout();
  //   this.router.navigate(['/sign-in']);
  // }
}



// WEBPACK FOOTER //
// ./src/app/shared/interceptors/authentication.interceptor.ts